import React from 'react';
import '../../App.css';
import '../our-firm/ourFirm.css';

function OurFirm({ data }) {
    if (!data) return null; // safety check

    return (
        <section className="our-firm">
            <div className="container">
                {/* Main heading and description */}
                <div dangerouslySetInnerHTML={{ __html: data?.aboutcon2 }} />

                <div className="firm-row row">
                    <div className="col-md-7">
                        <div className="firm-left">
                            {/* Who we are / How we run cases / What you can expect */}
                            <div dangerouslySetInnerHTML={{ __html: data?.title1 }} />

                            {/* Metrics */}
                            <div className="firm-metric">
                                {data?.title2 && (
                                    <div className="firm-chip" dangerouslySetInnerHTML={{ __html: data.title2 }} />
                                )}
                                {data?.title3 && (
                                    <div className="firm-chip" dangerouslySetInnerHTML={{ __html: data.title3 }} />
                                )}
                                {data?.description && (
                                    <div className="firm-chip" dangerouslySetInnerHTML={{ __html: data.description }} />
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="col-md-5">
                        <div className="firm-right">
                            {/* Proof cards */}
                            {data?.overpaid_title && (
                                <div className="proof-card">
                                    <div className="proof-icon">🏛️</div>
                                    <div className="prf-cont" dangerouslySetInnerHTML={{ __html: data.overpaid_title }} />
                                </div>
                            )}

                            {data?.newcolumn1 && (
                                <div className="proof-card">
                                    <div className="proof-icon">🎯</div>
                                    <div className="prf-cont" dangerouslySetInnerHTML={{ __html: data.newcolumn1 }} />
                                </div>
                            )}

                            {data?.newcolumn2 && (
                                <div className="proof-card">
                                    <div className="proof-icon">🤝</div>
                                    <div className="prf-cont" dangerouslySetInnerHTML={{ __html: data.newcolumn2 }} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default OurFirm;
